import React from 'react';
import './../../assets/components/ButtonGroup.css';

const ButtonGroup = ({ children }) => {
    return (
        <div className="appButtonGroup">
            {children}
        </div>
    );
};

export default ButtonGroup;
